import React from 'react'
import { Row, Col } from 'antd'

export const HIDDEN_CONTENT_TOOLTIP_TEXT =
  'View of test items is restricted by the Admin'

const hiddenTooltipContent = (
  <Row type="flex" justify="start">
    <Col className="classboard-tooltip-key">{HIDDEN_CONTENT_TOOLTIP_TEXT}</Col>
  </Row>
)

// NOTE: update `ariaLabel` in bar chart when visible tooltip content is updated
// ref. src/client/author/ClassBoard/components/BarGraph/BarGraph.js
const getVisibleTooltipContent = (payload) => {
  const [
    {
      value: correctAttempts,
      payload: { avgTimeSpent },
    },
    { value: incorrectAttempts },
    { value: partialAttempts },
  ] = payload

  const timeSpentInSeconds = avgTimeSpent ? (avgTimeSpent / 1000).toFixed(1) : 0

  return (
    <>
      <Row type="flex" justify="start">
        <Col className="classboard-tooltip-key">Correct Attempts: </Col>
        <Col className="classboard-tooltip-value">{correctAttempts}</Col>
      </Row>
      <Row type="flex" justify="start">
        <Col className="classboard-tooltip-key">Incorrect Attempts: </Col>
        <Col className="classboard-tooltip-value">{incorrectAttempts}</Col>
      </Row>
      <Row type="flex" justify="start">
        <Col className="classboard-tooltip-key">Partial Attempts: </Col>
        <Col className="classboard-tooltip-value">{partialAttempts}</Col>
      </Row>
      <Row type="flex" justify="start">
        <Col className="classboard-tooltip-key">
          Average Time Spent (seconds):{' '}
        </Col>
        <Col className="classboard-tooltip-value">{timeSpentInSeconds} </Col>
      </Row>
    </>
  )
}

export const CustomTooltip = (props) => {
  const { label, payload, className } = props

  // show tooltip if all attempts data is present
  const showToolTip = payload && payload.length >= 4
  if (!showToolTip) {
    return null
  }

  const tooltipContentId = `tootlip-${payload[0].payload?.itemId}`
  const isTooltipContentHidden = payload[0].payload?.hiddenAttempt

  const tooltipContent = isTooltipContentHidden
    ? hiddenTooltipContent
    : getVisibleTooltipContent(payload)

  return (
    <div className={className} id={tooltipContentId} role="tooltip">
      <div className="classboard-tooltip-title">{label}</div>
      {tooltipContent}
    </div>
  )
}
